import {marked} from "marked"
import Parser, {Config} from "./parse";

export default class Marked extends Parser {
  render(content: string, option: Config = {
    lineNumbers: false,
    getHeadingId: (s: string) => s
  }): string {
    const renderer = Object.assign(
      new marked.Renderer(),
      this.parser(option)
    );
    marked.setOptions({renderer});
    return marked(content);
  }
}
